import { UseFormGetValues, UseFormSetValue, useFieldArray, useForm } from "react-hook-form";
import { Action } from "../../enums/action.enums";
import {
  BCButton,
  BCFormList,
  BCFormListCont,
  BCFormOptionsHeader,
  BCFormOptionsList,
  BCFormOptionsListCont,
} from "../../styled/global.styled";
import { FormBase, OptionsSelect } from "../../interface/form-base";
import { Api } from "../../../core/services/api.services";
import { useService } from "../../../hook/useServices";
import SwitchFields from "../Bc-SwitchFields/Bc-SwitchFields";
import { useEffect, useState } from "react";
import BcIcon from "../Bc-Icon/Bc-icon";

const getFields = async () => {
  const { data } = await Api.getFields();
  return data;
};

interface Props {
    fieldPather: string;
    action: string;
    getValuesPather: UseFormGetValues<any>;
    setValuePather: UseFormSetValue<any>;
}

const BcFieldsBuilder = ({ fieldPather, action, setValuePather, getValuesPather }: Props) => {
  const [fieldsList, setFieldsList] = useState<FormBase[]>([]);
  const [actionFn, setActionFn] = useState<string>(action);
  const [labelBtn, setLabelBtn] = useState<string>('Agregar');
  const [indexField, setIndexField] = useState<number>(NaN);
  const serviceQuery = useService("fields", getFields);
  const dataFields = serviceQuery.data as unknown as any[];
  const fieldsOptions: OptionsSelect[] = dataFields?.map((field: any) => ({
    value: field.code,
    name: field.name,
  }));

  const FieldsForm: FormBase[] = [
    {
      item: "item",
      label: "Identificador del campo",
      placeholder: "Nombre del atributo del objeto del formulario",
      type: "text",
      isRequired: true,
    },
    {
      item: "label",
      label: "Label del campo",
      placeholder: "Ingresa el nombre del campo a mostrar",
      type: "text",
      isRequired: true,
    },
    {
      item: "placeholder",
      label: "Placeholder",
      placeholder: "Ingresa el placeholder",
      type: "text",
      isRequired: true,
    },
    {
      item: "type",
      label: "Tipo del campo",
      placeholder: "Nombre del Tipo del objeto del formulario",
      type: "select",
      options: fieldsOptions,
      isRequired: true,
    },
  ];

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    reset,
    control,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "options",
  });
  const onSubmit = handleSubmit((data) => {
    console.log(data);
    if (actionFn === Action.CREATE) {
        saveFields(data);
    } else {
        editFields(data, indexField);
    }
    
  });

  const saveFields = (data: any) => {
    console.log(data);
    const addFields: FormBase[] = [...getValuesPather(fieldPather)];
    addFields.push(data);
    setFieldsList(addFields);
    setValuePather(fieldPather, addFields, { shouldValidate: true });
    console.log(getValuesPather(fieldPather));
    reset();
  }

  const removeField = (index: number) => {
    const newFields = [...fieldsList];
    newFields.splice(index, 1);
    console.log(newFields);
    setFieldsList(newFields);
    setValuePather(fieldPather, newFields, { shouldValidate: true });
    console.log(getValuesPather(fieldPather));
  };

  const editField = (index: number) => {
    const fieldEdit = fieldsList[index];
    setValue('item', fieldEdit.item);
    setValue('label', fieldEdit.label);
    setValue('placeholder', fieldEdit.placeholder);
    setValue('type', fieldEdit.type);
    if (fieldEdit.options) {
        setValue('options', fieldEdit.options);
    }
    setActionFn(Action.EDIT);
    setIndexField(index);
    setLabelBtn('Editar');
  }

  const editFields = (data: any, index: number) => {
    const editFields = [...fieldsList];
    editFields[index] = data;
    setFieldsList(editFields);
    setValuePather(fieldPather, editFields, { shouldValidate: true });
    setActionFn(Action.CREATE);
    setLabelBtn('Agregar');
    setIndexField(NaN);
    reset();

  }

  const watchField = watch("type");

  useEffect(() => {
    if (watchField !== "select" || watchField !== "multi_select") {
      unregister("options");
    }
  }, [watchField]);

  return (
    <>
      <form onSubmit={onSubmit}>
        <BCFormList className="bc-card">
          <BCFormListCont>
            {FieldsForm.map((field: FormBase) => (
              <SwitchFields
                key={`fields${field.item}`}
                field={field}
                register={register}
                unregister={unregister}
                setValue={setValue}
                isRequired={field.isRequired}
                getValues={getValues}
                watch={watch}
                resetField={resetField}
              />
            ))}
          </BCFormListCont>
          <div className="bc-flex bc-justify-content-flex-end">
            <BCButton
              disabled={!isValid}
              className="bc-button-primary bc-button-small"
            >
              {labelBtn}
            </BCButton>
          </div>
          <BCFormOptionsList>
            {watchField === "select" || watchField === "multi_select" ? (
              <>
                <BCFormOptionsHeader>
                  <h6>Agregar una opcion de selección</h6>
                  <BCButton
                    type="button"
                    className="bc-button-secondary bc-button-small"
                    onClick={() => append({ name: "", value: "" })}
                  >
                    Agregar Opción
                  </BCButton>
                </BCFormOptionsHeader>
                {fields.map((options, index) => {
                  const OptionSelect: FormBase[] = [
                    {
                      label: "Nombre",
                      item: `options[${index}].name`,
                      type: "text",
                      isRequired: true,
                    },
                    {
                      label: "Valor",
                      item: `options[${index}].value`,
                      type: "text",
                      isRequired: true,
                    },
                  ];
                  return (
                    <BCFormOptionsListCont key={options.id}>
                      {OptionSelect.map((option: FormBase) => (
                        <SwitchFields
                          field={option}
                          key={`options${option.item}`}
                          register={register}
                          unregister={unregister}
                          setValue={setValue}
                          isRequired={option.isRequired}
                          getValues={getValues}
                          watch={watch}
                          resetField={resetField}
                        />
                      ))}
                      <div className="bc-flex bc-justify-content-flex-end">
                        <BCButton
                          className="bc-button-primary bc-button-small"
                          type="button"
                          onClick={() => remove(index)}
                        >
                          <BcIcon iconName="erase" />
                        </BCButton>
                      </div>
                    </BCFormOptionsListCont>
                  );
                })}
              </>
            ) : null}
          </BCFormOptionsList>
        </BCFormList>
      </form>
      <div>
        {fieldsList ? (
          <>
            {fieldsList.map((field: FormBase, index: number) => (
              <BCFormList className="bc-card" key={field.item}>
                <BCFormListCont>
                  <span>
                    <h6>Item: </h6>
                    <p>{field.item}</p>
                  </span>
                  <span>
                    <h6>Label: </h6>
                    <p>{field.label}</p>
                  </span>
                  <span>
                    <h6>Tipo: </h6>
                    <p>{field.type}</p>
                  </span>
                  {field.options && <span>
                    <h6>Opciones: </h6>
                    <p>Tienen {JSON.stringify(field.options?.length)} opciones</p>
                  </span>}
                </BCFormListCont>
                <div className="bc-flex bc-justify-content-flex-end">
                  <BCButton
                    type="button"
                    className="bc-button-secondary bc-button-small"
                    onClick={() => editField(index)}
                  >
                    <BcIcon iconName="modify" />
                  </BCButton>
                  <BCButton
                    type="button"
                    className="bc-button-primary bc-button-small"
                    onClick={() => removeField(index)}
                  >
                    <BcIcon iconName="erase" />
                  </BCButton>
                </div>
              </BCFormList>
            ))}
          </>
        ) : null}
      </div>
    </>
  );
};

export default BcFieldsBuilder;
